import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { MdDelete } from "react-icons/md";
import { AiFillPlusCircle } from "react-icons/ai";
// import TimePicker from "react-time-picker";

export default function UpdateScheduleCampaign({
  type,
  getAxiosInstance,
  Toast,
  campaignUp,
  getCampaign,
}) {
  const [IsShowing, setIsShowing] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [campName, setCampName] = useState("");
  const [note, setNote] = useState("");
  const [startDate, setStartDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [schedules, setSchedules] = useState([]);
  const [uniqueDate, setUniqueDate] = useState([]);

  // console.log("66666666666666", campaignUp.start_time.split("T")[1]); s =[]
  const f_time = campaignUp.start_time.split("T")[1];
  // console.log("222222", f_time.substring(0, 5));
  // const uniqueDates = Array.from(
  //   new Set(schedules.map((e) => e.from_time.split("T")[0]))
  // );
  // console.log("6666666666666====>", uniqueDate);
  useEffect(() => {
    const uniqueDates = Array.from(
      new Set(schedules.map((e) => e.from_time?.toString().split("T")[0]))
    );
    const value = uniqueDates.map((item) => {
      let times = [];
      schedules.map((sdata) => {
        if (sdata.from_time) {
          console.log("s.fromtime===", sdata.from_time);
          const r = sdata.from_time?.toString().split("T")[0];
          if (r == item) {
            times.push(sdata);
          }
        }
      });
      return { date: item, time: [...times] };
    });
    setUniqueDate(value);
  }, [schedules]);
  useEffect(() => {
    if (campaignUp) {
      setCampName(campaignUp.name);
      setNote(campaignUp.notes);
      // setStartDate(campaignUp.start_time.split("T")[0])
      setStartDate(
        `${DateTime.fromMillis(
          new Date(campaignUp.start_time.split("T")[0]).getTime()
        ).toFormat("yyyy-LL-dd")}`
      );
      setEndDate(
        `${DateTime.fromMillis(
          new Date(campaignUp.end_time.split("T")[0]).getTime()
        ).toFormat("yyyy-LL-dd")}`
      );
      setFromTime(formatTime(campaignUp.start_time.split("T")[1]));
      setToTime(formatTime(campaignUp.end_time.split("T")[1]));

      setSchedules(campaignUp.schedules);
    }
  }, [campaignUp]);

  useEffect(() => {
    if (campaignUp) {
      setFromDate(
        `${DateTime.fromMillis(
          new Date(campaignUp.start_time).getTime()
        ).toFormat("yyyy-LL-dd")}T${campaignUp.from_time}`
      );
      setTillDate(
        `${DateTime.fromMillis(
          new Date(campaignUp.end_time).getTime()
        ).toFormat("yyyy-LL-dd")}T${campaignUp.to_time}`
      );
    }
  });
  // console.log("bbbbbbbbbbbb", fromDate, tillDate);

  // const formattedFromTime

  const formatToTime = (timeString) => {
    // console.log("abdu", timeString);
    if (!timeString) {
      return "";
    }
    const time = timeString.split("T")[1].split(":").slice(0, 2).join(":");
    const date = new Date(`2000-01-01T${time}Z`); // Append 'Z' to indicate UTC time
    const hours = ("0" + date.getHours()).slice(-2); // Two-digit hours with leading zero if necessary
    const minutes = ("0" + date.getMinutes()).slice(-2); // Two-digit minutes with leading zero if necessary

    // Format the time
    const formattedTime = hours + ":" + minutes;
    return formattedTime;
  };
  const formatFromTime = (timeString) => {
    console.log("time staing", timeString);
    if (!timeString) {
      return "";
    }
    const time = timeString.split("T")[1].split(":").slice(0, 2).join(":");

    const date = new Date(`2000-01-01T${time}Z`); // Append 'Z' to indicate UTC time

    const hours = ("0" + date.getHours()).slice(-2); // Two-digit hours with leading zero if necessary
    const minutes = ("0" + date.getMinutes()).slice(-2); // Two-digit minutes with leading zero if necessary

    // Format the time
    const formattedTime = hours + ":" + minutes;

    return formattedTime;
  };

  const formatTime = (timeString) => {
    if (!timeString) {
      return "";
    }
    const time = timeString.split(":").slice(0, 2).join(":");

    const date = new Date(`2000-01-01T${time}Z`); // Append 'Z' to indicate UTC time

    const hours = ("0" + date.getHours()).slice(-2); // Two-digit hours with leading zero if necessary
    const minutes = ("0" + date.getMinutes()).slice(-2); // Two-digit minutes with leading zero if necessary

    // Format the time
    const formattedTime = hours + ":" + minutes;

    return formattedTime;
  };

  const formattedFromTime = fromTime ? formatTime(fromTime) : "";

  const formattedToTime = toTime ? formatTime(toTime) : "";

  // const handleInputChange1 = (event) => {
  //   // console.log("11111111==", inputValue)
  //   const inputValue = event.target.value;
  // const timePattern = /^(0[0-9]|1[0-2]):([0-5][0-9])\s(AM|PM)$/;

  // if (inputValue === '' || timePattern.test(inputValue)) {
  //   // Update the state with the input value
  //   setFromTime(inputValue);
  // }
  // };
  const resetUniqueDates = () => {
    const uniqueDates = Array.from(
      new Set(schedules.map((e) => e.from_time.toString().split("T")[0]))
    );

    const value = uniqueDates.map((item) => {
      let times = [];
      schedules.map((sdata) => {
        const r = sdata.from_time.toString().split("T")[0];
        if (r == item) {
          times.push(sdata);
        }
      });
      return { date: item, time: [...times] };
    });
    setUniqueDate(value);
    setStartDate(
      `${DateTime.fromMillis(
        new Date(campaignUp.start_time.split("T")[0]).getTime()
      ).toFormat("yyyy-LL-dd")}`
    );
    setEndDate(
      `${DateTime.fromMillis(
        new Date(campaignUp.end_time.split("T")[0]).getTime()
      ).toFormat("yyyy-LL-dd")}`
    );
    setFromTime(formatTime(campaignUp.start_time.split("T")[1]));
    setToTime(formatTime(campaignUp.end_time.split("T")[1]));
  };
  const handleInputChange1 = (event) => {
    const inputValue = event.target.value;

    setFromTime(inputValue);
    // const d = schedules.map((time) => ({
    //   ...time,
    //   from_time: new Date(
    //     `${time.from_time.split("T")[0]} ${inputValue}`
    //   ).toISOString(),
    // }));

    // setSchedules([...d]);
    const dates = [...uniqueDate];
    const updatedDates = dates.map((date) => ({
      ...date,
      time: date.time.map((dt) => ({
        ...dt,
        from_time: new Date(
          `${dt.from_time.split("T")[0]} ${inputValue}`
        ).toISOString(),
      })),
    }));
    setUniqueDate([...updatedDates]);
    // event.target.blur();
  };

  // const handleTimeChange = (newTime) => {
  //   setFromTime(newTime);
  //   console.log("jjjj", newTime)
  // };
  const handleInputChange2 = (event) => {
    // console.log("11111111==", inputValue)
    const inputValue = event.target.value;
    setToTime(inputValue);
    const dates = [...uniqueDate];

    const updatedDates = dates.map((date) => ({
      ...date,
      time: date.time.map((dt) => ({
        ...dt,
        to_time: new Date(
          `${dt.to_time.split("T")[0]} ${inputValue}`
        ).toISOString(),
      })),
    }));
    setUniqueDate([...updatedDates]);

    // const toSchedule = schedules.map((time) => ({
    //   ...time,
    //   to_time: new Date(
    //     `${time.to_time.split("T")[0]} ${inputValue}`
    //   ).toISOString(),
    // }));
    // setToTime(inputValue);
    // setSchedules([...toSchedule]);

    // event.target.blur();
  };
  // const endDateHandler = (e) => {
  //   setEndDate(e.target.value);
  //   // console.log("hhhhhhhhh", endDate);
  //   let result = [];
  //   let currentDate = new Date(startDate); // 1-jan
  //   const endDate = new Date(e.target.value); //10
  //   while (currentDate <= endDate) {
  //     const previousDates = schedules.filter(
  //       (values) =>
  //         new Date(values.from_time).toLocaleDateString() ==
  //         currentDate.toLocaleDateString()
  //     );
  //     if (previousDates.length > 0) {
  //       result = [...result, ...previousDates];
  //     } else {
  //       // console.log("ffff", currentDate, fromTime);
  //       result.push({
  //         from_time: new Date(
  //           `${currentDate.toLocaleDateString()} ${fromTime}`
  //         ).toISOString(),
  //         to_time: new Date(
  //           `${currentDate.toLocaleDateString()} ${toTime}`
  //         ).toISOString(),
  //       });
  //     }
  //     // console.log("wwwwwwwwwwwww", previousDates);
  //     // break;
  //     currentDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 24);
  //   }
  //   // console.log("xxxxxxxxxxxxxxxxxxxxxx", result);
  //   setSchedules(result);
  // };
  const endDateHandler = (e) => {
    const newEDate = e.target.value;

    setEndDate(newEDate);
    const result = [];
    let currentDate = new Date(startDate);
    const endDate = new Date(newEDate);

    while (currentDate <= endDate) {
      const alreadyPresent = uniqueDate.find(
        (ud) => new Date(ud.date).getTime() == currentDate.getTime()
      );

      if (alreadyPresent) {
        result.push({
          date: alreadyPresent.date,
          time: [...alreadyPresent.time],
        });
      } else {
        const date = currentDate.toISOString().split("T")[0];
        result.push({
          date: date,
          time: [
            {
              from_time: new Date(`${date} ${fromTime}`).toISOString(),
              to_time: new Date(`${date} ${toTime}`).toISOString(),
            },
          ],
        });
      }
      // console.log("d", currentDate);
      currentDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 24);
      // console.log("t", currentDate);
    }

    setUniqueDate([...result]);
  };
  // const startDateHandler = (e) => {
  //   // console.log("startDateHandler====>", e.target.value);
  //   setStartDate(e.target.value);
  //   // console.log("hhhhhhhhh", endDate);
  //   let result = [];
  //   let currentDate = new Date(e.target.value); // 1-jan
  //   const end = new Date(endDate); //10
  //   while (currentDate <= end) {
  //     const previousDates = schedules.filter(
  //       (values) =>
  //         new Date(values.from_time).toLocaleDateString() ==
  //         currentDate.toLocaleDateString()
  //     );
  //     if (previousDates.length > 0) {
  //       result = [...result, ...previousDates];
  //     } else {
  //       // console.log("ffff", currentDate, fromTime);
  //       result.push({
  //         from_time: new Date(
  //           `${currentDate.toLocaleDateString()} ${fromTime}`
  //         ).toISOString(),
  //         to_time: new Date(
  //           `${currentDate.toLocaleDateString()} ${toTime}`
  //         ).toISOString(),
  //       });
  //     }
  //     // console.log("wwwwwwwwwwwww", previousDates);
  //     // break;
  //     currentDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 24);
  //   }
  //   // console.log("xxxxxxxxxxxxxxxxxxxxxx", result);
  //   setSchedules(result);
  // };
  const startDateHandler = (e) => {
    const newSDate = e.target.value;
    setStartDate(newSDate);
    const result = [];
    let currentDate = new Date(newSDate);
    const eDate = new Date(endDate);
    while (currentDate <= eDate) {
      const alreadyPresent = uniqueDate.find(
        (ud) => new Date(ud.date).getTime() == currentDate.getTime()
      );
      if (alreadyPresent) {
        result.push({
          date: alreadyPresent.date,
          time: [...alreadyPresent.time],
        });
      } else {
        const date = currentDate.toISOString().split("T")[0];
        result.push({
          date: date,
          time: [
            {
              from_time: new Date(`${date} ${fromTime}`).toISOString(),
              to_time: new Date(`${date} ${toTime}`).toISOString(),
            },
          ],
        });
      }
      currentDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 24);
    }

    setUniqueDate([...result]);
  };
  // const handleFromTimeChange = (event, date) => {
  //   const storedDate = date.split("T")[0];
  //   const updatedFromTime = new Date(
  //     `${storedDate} ${event.target.value}`
  //   ).toISOString();
  //   const updatedDates = schedules.map((time) => {
  //     if (time.from_time == date) {
  //       return {
  //         ...time,
  //         from_time: updatedFromTime,
  //       };
  //     }

  //     return { ...time };
  //   });

  //   setSchedules(updatedDates);
  // };
  const handleFromTimeChange = (event, targetTime, date, index) => {
    const newTime = new Date(`${date} ${event.target.value}`);
    const target = uniqueDate.findIndex((ud) => ud.date == date);
    const tIndex = uniqueDate[target].time.findIndex(
      (tt, i) => tt.from_time == targetTime && i == index
    );
    const res = {
      ...uniqueDate[target].time[tIndex],
      from_time: newTime.toISOString(),
    };
    const updatedResult = [...uniqueDate];

    updatedResult[target].time.splice(tIndex, 1, res);

    setUniqueDate([...updatedResult]);
  };
  // const handleToTimeChange = (event, date) => {
  //   // console.log(" indexxx===handleFromTimeChange====>", index);
  //   const storedDate = date.split("T")[0];

  //   const updatedToTime = new Date(
  //     `${storedDate} ${event.target.value}`
  //   ).toISOString();

  //   const updatedDates = schedules.map((time) => {
  //     if (time.to_time == date) {
  //       return {
  //         ...time,
  //         to_time: updatedToTime,
  //       };
  //     }

  //     return { ...time };
  //   });

  //   setSchedules(updatedDates);
  // };
  const handleToTimeChange = (event, targetTime, date, index) => {
    const newTime = new Date(`${date} ${event.target.value}`);
    const target = uniqueDate.findIndex((ud) => ud.date == date);
    const tIndex = uniqueDate[target].time.findIndex(
      (tt, i) => tt.to_time == targetTime && index == i
    );
    const res = {
      ...uniqueDate[target].time[tIndex],
      to_time: newTime.toISOString(),
    };
    const updatedResult = [...uniqueDate];
    updatedResult[target].time.splice(tIndex, 1, res);
    setUniqueDate([...updatedResult]);
  };
  const updateCampaign = () => {
    if (startDate === "")
      return Toast.fire({ icon: "error", title: "Campaign start required" });
    if (endDate === "")
      return Toast.fire({ icon: "error", title: "Campaign end required" });
    if (new Date(`${endDate}`) <= new Date(`${startDate}`)) {
      return Toast.fire({
        icon: "error",
        title: "End date cannot be less or equal to start date",
      });
    }
    // if (fromDate === "")
    //   return Toast.fire({ icon: "error", title: "Campaign start required" });
    // if (tillDate === "")
    //   return Toast.fire({ icon: "error", title: "Campaign end required" });

    const parsedSchedules = [];
    let completionTime = new Date();
    uniqueDate.forEach((date) => {
      date.time.forEach((timestamp) => {
        if (completionTime < new Date(timestamp.to_time)) {
          completionTime = new Date(timestamp.to_time);
        }

        parsedSchedules.push({
          ...timestamp,
        });
      });
    });

    let scheduledStartTime = new Date(`${startDate} ${fromTime}`);
    let scheduledEndTime = completionTime;
    let scheduledFromTime = fromTime;
    let scheduledToTime = toTime;
    let currentTime = new Date().getTime();

    // if (currentTime >= scheduledStartTime)
    //   return Toast.fire({ icon: "error", title: "Cannot schedule on past." });
    // if (scheduledEndTime <= scheduledStartTime)
    //   return Toast.fire({
    //     icon: "error",
    //     title: "Cannot end before campaign start.",
    //   });

    setIsLoading(true);
    let link = "/admin/add-campaign";
    let params = {
      startTime: scheduledStartTime,
      endTime: scheduledEndTime,
      fromTime: scheduledFromTime,
      toTime: scheduledToTime,
      name: campName,
      notes: note,
      schedules: JSON.stringify(parsedSchedules),
    };
    if (campaignUp) {
      params["id"] = campaignUp._id;
      link = "/admin/update-campaign";
    }

    const data = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");
    // console.log("data---->", data);
    getAxiosInstance()
      .post(link, data, {
        // headers: { "Content-Type": "application/x-www-form-urlencoded" },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        console.log(res.data);
        if (res.data.status === "success") {
          Toast.fire({
            icon: "success",
            title: `Country ${
              type === "add" ? "added" : "updated"
            } successfully.`,
          });
          handleClose();
          getCampaign();
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot Process Request" });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401)
          Toast.fire({ icon: "error", title: "Unauthorized Access" });
        console.log(err);
      });
  };
  // const deleteScheduleTimeHandler = (s, i, ui) => {
  //   console.log("deleteScheduleTimeHandler==>", s);
  //   console.log("inddex deleteScheduleTimeHandler==>", i);
  //   console.log("inddex deleteScheduleTimeHandler==>", ui);
  //   const targetedDate = s.from_time.split("T")[0];
  //   console.log("targetedDate===>", targetedDate);
  //   const updatedSchedules = [...uniqueDate]; // Create a copy of the schedules array [date, time]
  //   const t = updatedSchedules.findIndex((e) => targetedDate == e.date); // index [ time]
  //   console.log("ttttttttttttttttt", t);
  //   updatedSchedules[t].time.splice(i, 1);
  //   setUniqueDate(updatedSchedules);
  // };
  const deleteScheduleTimeHandler = (s, i, ui) => {
    console.log("deleteScheduleTimeHandler==>", s);
    console.log("inddex deleteScheduleTimeHandler==>", i);
    console.log("inddex deleteScheduleTimeHandler==>", ui);
    const targetedDate = s.from_time.split("T")[0];
    const updatedSchedules = [...uniqueDate]; // Create a copy of the schedules array
    const targetIndex = updatedSchedules.findIndex(
      (e) => e.date === targetedDate
    );
    if (targetIndex < 0) {
      console.log(updatedSchedules);
      const targetTime = updatedSchedules[ui].time;
      targetTime.splice(i, 1);
      updatedSchedules[ui].time = targetTime;
      if (updatedSchedules[ui].time.length === 0) {
        updatedSchedules.splice(ui, 1);
      }
    }
    updatedSchedules[ui].time.splice(i, 1);
    console.log("Updated schedules:", updatedSchedules);
    setUniqueDate(updatedSchedules);
  };

  const addMoreScheduleHandler = (s, i) => {
    console.log("addMoreScheduleHandler====>", s);
    console.log("addMoreScheduleHandler====>", i);
    console.log("yuuuuuuuuuuuuuuu", uniqueDate);
    const targetedDate = s.from_time.split("T")[0];
    console.log("date----->", targetedDate);
    const updatedSchedules = [...uniqueDate];
    const index = updatedSchedules.findIndex((e) => targetedDate == e.date);
    console.log("index====>", index);
    updatedSchedules[index].time.push({ from_time: "", to_time: "" });
    setUniqueDate(updatedSchedules);
    // const q = updatedSchedules.filter((e) => {
    //   if (e.date == targetedDate) {
    //     const r = e.time.push({ from_time: "", to_time: "" });
    //     return r;
    //   }
    // });
    // console.log("wwwww", updatedSchedules);
    // console.log("qqqqqq", q);
    // setUniqueDate(updatedSchedules);
  };
  function handleClose() {
    setIsShowing(false);
    setFromDate("");
    setTillDate("");
    // window.location.reload()
  }

  return (
    <>
      {type === "add" && (
        <button
          type="button"
          class="btn btn-dark btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-plus"></i> Add Country
        </button>
      )}
      {type !== "add" && (
        <button
          type="button"
          title="Edit"
          class="btn btn-success btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-pen"></i>
        </button>
      )}
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content" style={{ width: "600px" }}>
              <div className="modal-header">
                <h5 className="modal-title">Edit Campaign</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    resetUniqueDates();
                    handleClose();
                  }}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        className="form-control mt-1"
                        id="campaign"
                        placeholder={"Enter Campaign Name"}
                        value={campName}
                        onChange={(e) => setCampName(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <textarea
                        className="form-control mt-1"
                        id="notes"
                        placeholder={"Additional Notes"}
                        value={note}
                        style={{ resize: "none" }}
                        rows={5}
                        onChange={(e) => setNote(e.target.value)}
                      />
                    </div>
                    {/* {schedule && ( */}
                    <>
                      <div className="form-group row m-auto" style={{}}>
                        <div className="col-md-4 mb-2" style={{ padding: "0" }}>
                          <div
                            className="form-group row m-auto"
                            style={{
                              // border: "1px solid blue",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                flex: "1",
                                marginBottom: "0",
                                // border: "1px solid red",
                              }}
                              className="text-left"
                            >
                              Start Date
                            </p>
                            <input
                              type="date"
                              className="form-control bg-light col-md-7 ml-1"
                              placeholder="DD/MM/YYYY"
                              style={{
                                fontSize: "12px",
                                textAlign: "center",
                                padding: " 0",
                                margin: "0 !important",
                              }}
                              value={startDate}
                              // onChange={(e) => setStartDate(e.target.value)}
                              min={new Date().toISOString().split("T")[0]}
                              onChange={startDateHandler}
                            />
                          </div>
                        </div>
                        <div className="col-md-4" style={{ padding: "0" }}>
                          <div
                            className="form-group row m-auto"
                            style={{
                              fontSize: "13px",
                              // border: "1px solid blue",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                // border: "1px solid red",
                                marginBottom: "0",
                                flex: "1",
                              }}
                              className="text-center"
                            >
                              From
                            </p>
                            {/* {showFromTimeInput ? (
                                <input
                                  type="time"
                                  className="form-control bg-light col-md-8 mr-1"
                                  placeholder="HH/MM"
                                  style={{
                                    // border: "1px solid red",
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  // onChange={(e) => setFromTime(e.target.value)}
                                />
                              ) : ( */}

                            <input
                              type="time"
                              className="form-control bg-light col-md-8 mr-1"
                              style={{
                                marginLeft: "15px",
                                fontSize: "13px",
                              }}
                              placeholder="HH:MM AM/PM"
                              onChange={handleInputChange1}
                              value={fromTime}
                            />

                            {/* <TimePicker
        className="form-control bg-light col-md-8 mr-1"
        style={{
          marginLeft: "15px",
          fontSize: "13px",
        }}
        format="hh:mm a"
        value={fromTime}
        onChange={handleTimeChange}
      /> */}

                            {/* <input
  type="time"
  className="form-control bg-light col-md-8 mr-1"
  style={{
    marginLeft: "15px",
    fontSize: "13px",
  }}
  onChange={handleInputChange1}
  value={fromTime}
/> */}

                            {/* )} */}
                          </div>
                        </div>
                        <div className="col-md-4" style={{ padding: "0" }}>
                          <div
                            className="form-group row m-auto"
                            style={{
                              // width: "182px",
                              fontSize: "13px",
                              // border: "1px solid blue",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                // border: "1px solid red",
                                marginBottom: "0",
                                flex: "1",
                              }}
                              className=" text-center"
                            >
                              To
                            </p>
                            {/* {showToTimeInput ? (
                                <input
                                  type="time"
                                  className="form-control bg-light col-md-8 mr-1"
                                  placeholder="HH/MM"
                                  style={{
                                    //   border: "1px solid red",
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  // onChange={(e) => setToTime(e.target.value)}
                                />
                              ) : ( */}

                            <input
                              type="time"
                              className="form-control bg-light col-md-8 mr-1"
                              style={{
                                marginLeft: "15px",
                                fontSize: "13px",
                              }}
                              placeholder="HH:MM PM/AM"
                              value={toTime}
                              onChange={handleInputChange2}
                            />

                            {/* <input
                              type="time"
                              className="form-control bg-light col-md-8 mr-1"
                              style={{
                                marginLeft: "15px",
                                fontSize: "13px",
                              }}
                              placeholder="HH:MM AM/PM"
                              onChange={handleInputChange1}
                              value={formattedFromTime}
                            /> */}
                            {/* )}   */}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row m-auto" style={{}}>
                        <div className="col-md-4" style={{ padding: "0" }}>
                          <div
                            className="form-group row m-auto"
                            style={{
                              // border: "1px solid blue",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "13px",
                                flex: "1",
                                marginBottom: "0",
                                // border: "1px solid red",
                              }}
                              className="text-left"
                            >
                              End Date
                            </p>
                            <input
                              type="date"
                              className="form-control bg-light col-md-7 ml-1"
                              placeholder="DD/MM/YYYY"
                              style={{
                                fontSize: "12px",
                                padding: " 0",
                                margin: "0 !important",
                                textAlign: "center",
                              }}
                              value={endDate}
                              min={new Date().toISOString().split("T")[0]}
                              onChange={endDateHandler}
                              // onChange={(e) => setEndDate(e.target.value)}
                              // onChange={
                              //   (e) => setEndDate(e.target.value)
                              // }
                              // onChange={endDateHandler}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                    {/* )} */}

                    <div className="form-control bg-gray-light my-3">
                      <p style={{ fontSize: "14px" }}>Broadcast Dates</p>
                    </div>

                    {uniqueDate.map((e, ui) => {
                      // console.log("ttttttttt", e);
                      return (
                        <div
                          key={e.date}
                          className=" row m-auto my-3"
                          style={{
                            // border: "1px solid red",
                            // marginBottom: "10px",
                            paddingBottom: "4px",
                          }}
                        >
                          <div
                            className="col-md-3"
                            style={{
                              // border: "1px solid red",
                              padding: "0",
                              margin: "0",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                // alignItems: "center",
                              }}
                              className=" h-100"
                            >
                              <p
                                style={{
                                  fontWeight: "600",
                                  // border: "1px solid blue",
                                  flex: "1",
                                  marginBottom: "2px",
                                  paddingTop: "7px",
                                }}
                                className="text-center"
                              >
                                {e.date}
                                {/* 12/06/2023 */}
                                {/* {e.from_time.split("T")[0]} */}
                              </p>
                            </div>
                          </div>

                          {/* from to div start */}
                          <div
                            className="col-md-9"
                            style={
                              {
                                // border: "1px solid red",
                              }
                            }
                          >
                            {e.time.map((f, index) => {
                              // console.log("fffffffffff==", f);
                              // if (f.from_time.toString().split("T")[0] === e)
                              return (
                                <div
                                  key={f.from_time + Math.random()}
                                  style={{ marginBottom: "3px" }}
                                  className=" row"
                                >
                                  <div
                                    className="col-md-5"
                                    style={{
                                      padding: "0",
                                      // border: "1px solid red",
                                    }}
                                  >
                                    <div
                                      className="d-flex justify-content-space-between align-items-center"
                                      // style={{ border: "1px solid red" }}
                                    >
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          flex: "1",
                                          marginBottom: "0",
                                        }}
                                        className="text-left box"
                                      >
                                        From
                                      </p>
                                      <input
                                        type="time"
                                        className="form-control bg-light col-md-8 ml-2 "
                                        placeholder="HH/MM"
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "center",
                                          marginLeft: "auto",
                                          marginRight: "auto",
                                        }}
                                        value={formatFromTime(f.from_time)}
                                        onChange={(event) =>
                                          handleFromTimeChange(
                                            event,
                                            f.from_time,
                                            e.date,
                                            index
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-5"
                                    style={{
                                      padding: "0",
                                      // border: "1px solid red",
                                    }}
                                  >
                                    <div
                                      className="d-flex justify-content-space-between align-items-center"
                                      style={{}}
                                    >
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          flex: "1",
                                          marginBottom: "0",
                                        }}
                                        className="text-center box"
                                      >
                                        To
                                      </p>
                                      <input
                                        type="time"
                                        className="form-control bg-light col-md-8 ml-3 "
                                        placeholder="HH/MM"
                                        style={{
                                          fontSize: "12px",
                                        }}
                                        value={formatToTime(f.to_time)}
                                        onChange={(event) =>
                                          handleToTimeChange(
                                            event,
                                            f.to_time,
                                            e.date,
                                            index
                                          )
                                        }
                                      />
                                    </div>
                                  </div>

                                  {/* {e.time.length - 1 === index ? ( */}
                                  <div
                                    className="col-md-2"
                                    style={{
                                      padding: "0",
                                      // border: "1px solid blue",
                                      display: "flex",
                                      justifyContent: "center",
                                      // alignItems: "end",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "end",
                                        justifyContent: "center",
                                        // border: "1px solid red",
                                        flex: "1",
                                      }}
                                    >
                                      {index > 0 ? (
                                        <div
                                          style={{
                                            // border: "1px solid blue",
                                            flex: "1",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            // marginRight: "10px",
                                          }}
                                          onClick={deleteScheduleTimeHandler.bind(
                                            this,
                                            f,
                                            index,
                                            ui
                                          )}
                                        >
                                          <MdDelete
                                            style={{ fontSize: "18px" }}
                                          />
                                        </div>
                                      ) : null}
                                      {e.time.length - 1 == index ? (
                                        <div
                                          style={{
                                            // border: "1px solid blue",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flex: "1",
                                            cursor: "pointer",
                                          }}
                                          onClick={addMoreScheduleHandler.bind(
                                            this,
                                            f,
                                            index
                                          )}
                                        >
                                          <AiFillPlusCircle
                                            style={{ fontSize: "18px" }}
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  {/* // ) : null} */}
                                </div>
                              );
                            })}
                          </div>
                          {/* from to div ends */}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={(e) => handleClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={(e) => updateCampaign()}
                  disabled={isLoading}
                >
                  {type === "add" ? "Add Country" : "Save changes"}
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Campaign Edit Modal</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        className="form-control mt-1"
                        type="datetime-local"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control mt-1"
                        type="datetime-local"
                        value={tillDate}
                        onChange={(e) => setTillDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={(e) => handleClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={(e) => updateCampaign()}
                  disabled={isLoading}
                >
                  {type === "add" ? "Add Country" : "Save changes"}
                </button>
              </div>
            </div>
          </div> */}
        </div>
      )}
    </>
  );
}
